<template>
    <div>
        <treeselect
            multiple
            v-model="model"
            :name="name"
            :options="options"
            noResultsText="Nichts gefunden"
            placeholder=""
        >
            <div slot="before-list" class="tw-flex tw-gap-2 tw-p-2">
                <button @click="selectAll()" type="button" class="cu-btn-xs">alle auswählen</button>
                <button @click="deselectAll()" type="button" class="cu-btn-xs">alle abwählen</button>
            </div>
        </treeselect>
    </div>
</template>

<script>
    import treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    export default {
        components: { treeselect },

        props: {
            options: Array,
            name: String,
            value: Array,
        },

        data() {
            return {
                model: null,
            }
        },

        mounted() {
            // prefill old values
            this.model = this.value ? this.value : null
        },

        methods: {
            selectAll() {
                this.model = [];
                this.options.forEach((item) => {
                    this.model.push(item.id);
                });
            },

            deselectAll() {
                this.model = [];
            }
        }
    }
</script>

<style scoped>
    /* make the placeholder black so it matches other selects */
    .vue-treeselect__placeholder {
        color: black;
    }

    .vue-treeselect--focused .vue-treeselect__placeholder {
        color: #BDBDBD;
    }
</style>